import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import ModalBody from './_ModalBody'
import ModalFooter from './_ModalFooter'
import ModalHeader from './_ModalHeader'

interface Props {
  onClose: () => void
  sharedSession: {
    showSharedSession: boolean
    moduleName?: string
    sharedSessionLink?: string
    sharedSessionTitle?: string
  }
}

const UpsellModalModulesConfirmation = ({ onClose, sharedSession }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { showSharedSession, sharedSessionLink, sharedSessionTitle, moduleName } = sharedSession

  const features = [
    i18n.t('upsell.request_modal.confirmation.features.1'),
    i18n.t('upsell.request_modal.confirmation.features.2'),
    i18n.t('upsell.request_modal.confirmation.features.3'),
  ]

  const headerTitle = showSharedSession
    ? i18n.t('upsell.request_modal.confirmation.shared_sessions.title')
    : i18n.t('upsell.request_modal.success_title')
  const headerDescription = showSharedSession
    ? i18n.t('upsell.request_modal.confirmation.shared_sessions.description')
    : i18n.t('upsell.request_modal.confirmation.description')

  const handleDiscoverMore = () => {
    track(trackingEvents.marketplaceModules.visitModulesPage, {
      from: 'Request Upsell Modules Confirmation Modal',
    })
    navigate(navigation.discover.marketplaceModules.fullPath())
    onClose()
  }

  const handleSharedSessionClick = () => {
    if (!sharedSessionLink) return
    track(trackingEvents.upsell.clickSharedSessionLink, {
      link: sharedSessionLink,
      title: sharedSessionTitle,
    })

    window.open(sharedSessionLink, '_blank')
    navigate(navigation.discover.marketplaceModules.fullPath())
    onClose()
  }

  useEffect(() => {
    if (showSharedSession) {
      track(trackingEvents.upsell.seeSharedSessionOption, {
        module: moduleName,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showSharedSession])

  return (
    <Modal
      title=""
      onClose={onClose}
      background="radial-gradient(70% 100% at 90% 10%, rgb(218, 244, 236, 100) 0%, rgb(255, 255, 255) 80%)"
    >
      <Box style={{ marginTop: '-68px' }}>
        <Box paddingBottom="s16">
          <Text.Header3>{i18n.t('upsell.request_modal.confirmation.title')}</Text.Header3>
        </Box>
        <Box flexDirection="column" alignItems="center" gap="s24">
          <ModalHeader title={headerTitle} description={headerDescription} />
          <ModalBody
            features={features}
            sharedSession={sharedSession}
            onClick={handleSharedSessionClick}
          />
        </Box>
        {!showSharedSession && (
          <ModalFooter onClose={onClose} onDiscoverMore={handleDiscoverMore} />
        )}
      </Box>
    </Modal>
  )
}

export default UpsellModalModulesConfirmation
